module.exports = __webpack_public_path__ + "static/media/bakvodvar_nidurtog.bce68a2f.png";